import * as React from 'react';
import { FunctionComponent, PropsWithChildren } from 'react';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Box from '@mui/material/Box';

import BaseFormInputField from '../../../../../../shared/components/base-input-form-field/base-form-input-field';
import { VinFilterComponentProps } from '../../models/vin-filters-component.props';
import { AddOrRemoveButton } from '../add-or-remove-button/add-or-remove-button';

export const VinFilterComponent: FunctionComponent<VinFilterComponentProps> = (
  props: PropsWithChildren<VinFilterComponentProps>
): JSX.Element => {
  const {
    filterIndex,
    vinCriterion,
    isLastElement,
    onAddOrRemoveButtonClick,
    onChangeVinCriterion,
    handleBlur,
  } = props;

  return (
    <Box
      sx={{
        display: 'flex',
      }}
      data-testid="vin-filter-component"
    >
      <BaseFormInputField
        className="filters-array-input"
        id="vinCriteria"
        label="VIN Criteria"
        name="vinCriteria"
        onChange={onChangeVinCriterion(filterIndex)}
        onBlur={handleBlur}
        value={vinCriterion ?? ''}
      />

      <AddOrRemoveButton
        buttonIcon={isLastElement ? <AddIcon /> : <RemoveIcon />}
        onActionButton={onAddOrRemoveButtonClick(filterIndex, isLastElement)}
      />
    </Box>
  );
};
